import React from "react";
import Table from "rc-table";
import * as i18n from "util/i18n";
import { obj } from "prop-types";

const CreditBillsTable = ({ data }) => {
    const columns = [
        {
            title: i18n.get("credit.bills.transmitter.label"),
            dataIndex: "trasnitter",
            key: "trasnitter",
        },
        {
            title: i18n.get("credit.bills.beneficiary.label"),
            dataIndex: "beneficiary",
            key: "beneficiary",
        },
        {
            title: i18n.get("credit.bills.date.label"),
            dataIndex: "date",
            key: "date",
        },
        {
            title: i18n.get("credit.bills.type.label"),
            dataIndex: "type",
            key: "type",
        },
        {
            title: i18n.get("credit.bills.motive.label"),
            dataIndex: "motive",
            key: "motive",
        },
        {
            title: i18n.get("credit.bills.motive.disown.label"),
            dataIndex: "disown",
            key: "disown",
        },
    ];
    return (
        <div>
            <Table columns={columns} data={data} />
        </div>
    );
};

CreditBillsTable.propTypes = {
    data: obj,
};

CreditBillsTable.defaultProps = {
    data: {},
};

export default CreditBillsTable;
